import React, { useState } from "react";
import { Switch, Route } from "react-router-dom";
import moment from "moment";
import StatementUpload from "../../components/statements/StatementUpload/StatementUpload";
import StatementDetailsContainer from "../StatementsDetailsContainer/StatementsDetailsContainer";
import StatementsTableContainer from "../StatementsTableContainer/StatementsTableContainer";
import "./StatementsContainer.less";

const StatementsContainer = () => {
  const defaultSearchValues = {
    period: [moment().subtract(60, "day"), moment()],
    includeBatchStatusIds: [1, 2, 3, 4],
    batchIds: "",
    page: 0,
    size: 10,
  };

  const [statementsSearchParams, setStatementsSearchParams] = useState(defaultSearchValues);

  return (
    <div className="container_height">
      <Switch>
        <Route exact path="/statements">
          <StatementsTableContainer
            defaultSearchValues={defaultSearchValues}
            statementsSearchParams={statementsSearchParams}
            setStatementsSearchParams={setStatementsSearchParams}
          />
        </Route>
        <Route path="/statements/upload" component={StatementUpload} />
        <Route path="/statements/:statementId" component={StatementDetailsContainer} />
      </Switch>
    </div>
  );
};

export default StatementsContainer;
